const BTNACTION = {
  NAVIGATE: 3,
  GET_API_CALL: 1,
  POST_API_CALL: 2,
};

export default BTNACTION;
